import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=738d6ca0&scoped=true&"
import script from "./HistoryModal.vue?vue&type=script&lang=js&"
export * from "./HistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=738d6ca0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d6ca0",
  null
  
)

export default component.exports